import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmConfirmComponent } from './sm-confirm.component';
import { SmBtnModule } from '../sm-btn/sm-btn.module';



@NgModule({
  declarations: [SmConfirmComponent],
  imports: [
    CommonModule,
    SmBtnModule
  ],
  exports:[SmConfirmComponent]
})
export class SmConfirmModule { }
